import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export interface FormInputStyleProps {
  margin?: string;
  flex?: string;
  hasError?: boolean;
  inputWidth?: string;
  backgroundColor?: string;
  disabled?: boolean;
}

export const FormInputWrap = styled.div<FormInputStyleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.margin || "0"};
  flex: ${(p) => (p.flex ? p.flex : "")};
  flex-shrink: 0;
  width: 100%;
`;

export const FormInputLabel = styled.label`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.greyText};
  display: block;
  margin-bottom: 8px;
  transition: all 0.3s ease;
`;

export const FormInputStyle = styled.input<FormInputStyleProps>`
  background: ${(props) =>
    props.disabled
      ? theme.smokeWhite
      : props.backgroundColor || theme.whiteText};
  border: 1px solid
    ${(props) => {
      if (props.hasError) return theme.redText2;
      return theme.lightGreyText;
    }};
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  width: 100%;
  height: 44px;
  color: ${theme.blackText};
  transition: all 0.2s ease;

  &::placeholder {
    font-weight: 400;
    color: ${theme.lightBlack};
  }

  &:focus {
    outline: none;
    border: 1px solid
      ${(props) => (props.hasError ? theme.redText2 : theme.blueText)};
    background: ${theme.whiteText};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: ${theme.smokeWhite};
    border-color: ${theme.lightGreyText};
  }

  @media ${deviceType.mobile} {
    width: 100%;
  }
`;
